import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromTransportationDataStore from './state/transportation-data-store.reducer';

/* effects */
import { TransportationDataStoreEffects } from './state/transportation-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* TransportationDataStore State */
    StoreModule.forFeature(
      fromTransportationDataStore.featureKey,
      fromTransportationDataStore.reducer,
      { initialState: fromTransportationDataStore.initialState },
    ),
    EffectsModule.forFeature([TransportationDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class TransportationDataStoreModule {}
